import { Trans } from 'react-i18next'

import learningIsFunPNG from '~/assets/images/art/learning-fun.png'
import learningIsFunWEBP from '~/assets/images/art/learning-fun.webp'
import { HistoryInfoPageStyles as S } from '~/pages/history/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const LearningIsFunArt = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Learning is fun and exciting',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={learningIsFunWEBP} type="image/webp" />
            <img src={learningIsFunPNG} alt="Learning is fun and exciting" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="art" i18nKey="onboarding.learningIsFunArt.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="art" i18nKey="onboarding.learningIsFunArt.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default LearningIsFunArt
